import React, { useEffect, useRef } from 'react';
import { ArrowRight } from 'lucide-react';

const ProviderMark = ({ id }) => id === 'microsoft' ? (
  <span className="enterprise-auth-provider-mark enterprise-auth-provider-microsoft" aria-hidden="true"><i/><i/><i/><i/></span>
) : <span className="enterprise-auth-provider-mark enterprise-auth-provider-google" aria-hidden="true">G</span>;

const EmailStep = ({ email, error, busy, providers, onEmailChange, onContinue, onProvider, onRequestAccess }) => {
  const headingRef = useRef(null);
  useEffect(() => headingRef.current?.focus(), []);

  return (
    <div className="enterprise-auth-step">
      <h2 ref={headingRef} tabIndex="-1">Sign in</h2>
      <p className="enterprise-auth-intro">Enter your work email. We’ll take you to your organisation’s sign-in method.</p>
      <form onSubmit={onContinue} noValidate>
        <label htmlFor="auth-email">Work email</label>
        <input id="auth-email" data-testid="login-email" type="email" autoComplete="email" autoFocus value={email} onChange={(event) => onEmailChange(event.target.value)} aria-invalid={Boolean(error)} aria-describedby={error ? 'auth-email-error' : undefined} placeholder="name@organisation.com" />
        {error && <p id="auth-email-error" className="enterprise-auth-error" role="alert">{error}</p>}
        <button className="enterprise-auth-primary" type="submit" aria-busy={busy}>
          {busy ? 'Checking sign-in method…' : 'Continue'}<ArrowRight size={17}/>
        </button>
      </form>

      {providers.length > 0 && (
        <div className="enterprise-auth-providers">
          <div className="enterprise-auth-divider"><span>or</span></div>
          {providers.map((provider) => (
            <button key={provider.id} type="button" className="enterprise-auth-secondary" onClick={() => onProvider(provider)}>
              <ProviderMark id={provider.id}/>Continue with {provider.label}
            </button>
          ))}
        </div>
      )}

      <div className="enterprise-auth-access-callout">
        <p><strong>New organisation?</strong> <button type="button" className="enterprise-auth-link-button" onClick={onRequestAccess}>Request access</button></p>
      </div>
      <p className="enterprise-auth-help"><strong>Joining an existing organisation?</strong> Use the secure invitation link sent by your administrator.</p>
    </div>
  );
};

export default EmailStep;
